export default __webpack_public_path__ + "static/media/green-navigator.fa1a2440.jpg";